module.exports = __webpack_public_path__ + "static/media/group-no-data.48fc8cd4.png";